import {mapMutations} from "vuex";
export default {
  name: "promo",
  components:{
  },
  data(){
    return{

    }
  },
  props: {
    item: {
      type: Object,
      default:()=>({ homeMain: { homeMainTitle: '', homeMainText: '', homeMainButtonTitle: '' }, homeSection: {} })
    },
  },
  created() {
  },
  computed:{

  },
  methods:{
    ...mapMutations({
    })
  }
}
